import { render, staticRenderFns } from "./FigmaIntegration.vue?vue&type=template&id=7185c488&scoped=true&"
import script from "./FigmaIntegration.vue?vue&type=script&lang=js&"
export * from "./FigmaIntegration.vue?vue&type=script&lang=js&"
import style0 from "./FigmaIntegration.vue?vue&type=style&index=0&id=7185c488&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185c488",
  null
  
)

export default component.exports